import { FETCH_SUGGESTED } from './constants'

const initialState = {
  isFetching: false,
  suggested: []
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_SUGGESTED.REQUEST: {
      return {
        ...state,
        isFetching: true
      }
    }
    case FETCH_SUGGESTED.SUCCESS: {
      return {
        ...state,
        isFetching: false,
        suggested: action.suggested
      }
    }
    default: {
      return state
    }
  }
}
